import { render, staticRenderFns } from "./MaintainerArticle.vue?vue&type=template&id=0eec4058"
import script from "./MaintainerArticle.vue?vue&type=script&lang=js"
export * from "./MaintainerArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports